import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import { sorted } from "helpers";
import { LocationsLoadingBucket } from "src/store/api/generatedApi";

dayjs.extend(utc);

export interface LoadingInterval {
  start: Dayjs;
  end: Dayjs;
}

const withIntervalMerged = (
  intervals: readonly LoadingInterval[],
  interval: LoadingInterval
): LoadingInterval[] => {
  const previous = intervals.at(-1);
  if (!previous || previous.end.isBefore(interval.start)) {
    return [...intervals, interval];
  }
  return [
    ...intervals.slice(0, -1),
    {
      start: previous.start,
      end: previous.end.isAfter(interval.end) ? previous.end : interval.end,
    },
  ];
};

export const locationLoadingIntervals = (
  buckets: readonly LocationsLoadingBucket[]
): Map<string, LoadingInterval[]> =>
  sorted(
    buckets.map((bucket) => ({
      interval: {
        start: dayjs.utc(bucket.start),
        end: dayjs.utc(bucket.end),
      },
      locationNames: bucket.loading_location_names,
    })),
    (bucket) => bucket.interval.start.valueOf()
  ).reduce(
    (byLocation, { interval, locationNames }) =>
      locationNames.reduce(
        (accumulated, locationName) =>
          accumulated.set(
            locationName,
            withIntervalMerged(accumulated.get(locationName) ?? [], interval)
          ),
        byLocation
      ),
    new Map<string, LoadingInterval[]>()
  );
